import { render, staticRenderFns } from "./PatientListPage.vue?vue&type=template&id=16060c70&"
import script from "./PatientListPage.vue?vue&type=script&lang=js&"
export * from "./PatientListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports